import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/blocks/page.tsx");
